import PersonalBookingPageShownView from '../data/store/schema/PersonalBookingPageShownView';
import getStore from '../data/store/store';

export default function getShownView(): PersonalBookingPageShownView {
    return getStore().shownView;
}
